import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/api/EmployeeBilingual";

export const getEmployeeBilingual = async () => {
  const data = await axios.get(`${api_base_url}`);
  return data;
};

export const addEmployeeBilingual = async (newEmployeeBilingualdata) => {
  const newEmployeeBilingual = newEmployeeBilingualdata[0];
  const formData = new FormData();
  newEmployeeBilingual.bilingualId &&
    formData.append("bilingualId", newEmployeeBilingual.bilingualId);
  newEmployeeBilingual.bilingualName &&
    formData.append("bilingualName", newEmployeeBilingual.bilingualName);
  newEmployeeBilingual.createdBy &&
    formData.append("createdBy", newEmployeeBilingual.createdBy);
  newEmployeeBilingual.createdDate &&
    formData.append("createdDate", newEmployeeBilingual.createdDate);
  newEmployeeBilingual.isActive &&
    formData.append("isActive", newEmployeeBilingual.isActive);
  return axios.post(`${api_base_url}`, formData);
};

export const deleteEmployeeBilingual = async (ids) => {
  await axios.delete(`${api_base_url}`, {
    data: ids,
  });
};

export const updateEmployeeBilingual = async (editEmployeeBilingual) => {
  const formData = new FormData();
  editEmployeeBilingual.bilingualId &&
    formData.append("bilingualId", editEmployeeBilingual.bilingualId);
  editEmployeeBilingual.bilingualName &&
    formData.append("bilingualName", editEmployeeBilingual.bilingualName);
  editEmployeeBilingual.createdBy &&
    formData.append("createdBy", editEmployeeBilingual.createdBy);
  editEmployeeBilingual.createdDate &&
    formData.append("createdDate", editEmployeeBilingual.createdDate);
  editEmployeeBilingual.isActive !== null &&
    formData.append("isActive", editEmployeeBilingual.isActive);
  return axios.put(`${api_base_url}`, formData);
};
